import axios from 'api/axios'
import { Link } from 'react-router-dom'

async function generateMailto(to, params) {
  let mailtoLink = `mailto:${encodeURIComponent(to)}`
  const regex = /{[^}]+}/
  let subject = params?.ASUNTO || ''
  let body = params?.CUERPO || ''

  const hasVariables = regex.test(subject) || regex.test(body)

  try {
    if (hasVariables) {
      const response = await axios.post('/parse/', {
        subject: subject,
        body: body,
      })
      subject = response?.data?.subject
      body = response?.data?.body
    }
  } catch (error) {
    // Error parsing template
  }

  if (subject) mailtoLink += `?subject=${encodeURIComponent(subject)}`
  if (body) {
    mailtoLink += subject ? '&' : '?'
    mailtoLink += `body=${encodeURIComponent(body)}`
  }

  return mailtoLink
}

export const getMenuParams = (menu) => {
  let params = {}
  switch (menu.programa) {
    case 'url':
      params = {
        href: menu.camino,
        target: '_blank',
        rel: 'noopener noreferrer',
        component: 'a',
      }
      break
    case 'mailto':
      params = {
        onClick: async (e) => {
          e.preventDefault()
          const mailto = await generateMailto(menu.camino, menu.parametros)
          window.location.href = mailto
        },
      }
      break
    case 'informes':
      params = {
        to: `/${menu.camino ? menu.camino : menu.programa}`,
        component: Link,
        state: menu.objeto_programa ? { report: menu.objeto_programa } : {},
      }
      break
    default:
      params = {
        ...params,
        to: `/${menu.camino ? menu.camino : menu.programa}`,
        component: Link,
      }
  }

  return params
}
